// extracted by mini-css-extract-plugin
export default {"box":"WebService_box__au3+w"};